<template>
  <div>
    <SwappingSquaresSpinner v-if="this.$store.getters.isLoading"
      :animation-duration="1000"
      :size="90"
      :color="this.$store.getters.config.palette.primary"
      style="margin: 30px auto;"
    />
    <div style="color: #4ae387;" v-if="confirmEmailSuccessResponse !== null">
      {{confirmEmailSuccessResponse}}
    </div>
  </div>
</template>

<script>
import { SwappingSquaresSpinner } from 'epic-spinners'
import errorHandlerMixin from '@/mixin/errorHandlerMixin'
export default {
  components: { SwappingSquaresSpinner },
  name: 'EmailConfirmation',
  mixins: [errorHandlerMixin],
  data () {
    return {
      confirmEmailSuccessResponse: null,
    }
  },
  methods: {
    async successHandler (response) {
      this.confirmEmailSuccessResponse = response.data.message
      this.$store.commit('setLoading', false)
      await this.$router.push({ name: 'login' })
    },
  },
  mounted () {
    this.$store.commit('setLoading', true)
    this.$store.dispatch('confirmEmail', this.$route.params.token)
      .then((resp) => this.successHandler(resp))
      .catch((err) => this.errorHandler(err.response))
  },
}
</script>

<style scoped>

</style>
